"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GhostLink = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GhostLink = require("./GhostLink.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var RightIcon = function RightIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  }));
};

RightIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var LeftIcon = function LeftIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
  }));
};

LeftIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var UpIcon = function UpIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
  }));
};

UpIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var DownIcon = function DownIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
  }));
};

DownIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var GhostLink = function GhostLink(props) {
  var children = props.children,
      to = props.to,
      textColor = props.textColor,
      margin = props.margin,
      a11yTitle = props.a11yTitle,
      icon = props.icon;

  var linkComponentInner = _react.default.createElement(_react.default.Fragment, null, icon === 'left' && _react.default.createElement(LeftIcon, null), icon === 'up' && _react.default.createElement(UpIcon, null), _react.default.createElement(_GhostLink.StyledGhostLinkText, {
    textColor: textColor
  }, children), icon === 'right' && _react.default.createElement(RightIcon, null), icon === 'down' && _react.default.createElement(DownIcon, null));

  var linkComponent = to ? _react.default.createElement(_GhostLink.StyledGhostRouterLink, _extends({
    "aria-label": a11yTitle
  }, props), linkComponentInner) : _react.default.createElement(_GhostLink.StyledGhostLink, _extends({
    "aria-label": a11yTitle
  }, props), linkComponentInner);
  return _react.default.createElement(_GhostLink.StyledGhostLinkContainer, {
    textColor: textColor,
    margin: margin
  }, linkComponent);
};
/**
 * Definition of default values for component props
 */


exports.GhostLink = GhostLink;
GhostLink.defaultProps = {
  children: [],
  a11yTitle: '',
  textColor: '',
  margin: '',
  icon: '',
  to: undefined
};
GhostLink.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  a11yTitle: _propTypes.default.string,
  textColor: _propTypes.default.string,
  margin: _propTypes.default.string,
  icon: _propTypes.default.oneOf(['', 'left', 'right', 'up', 'down']),
  to: _propTypes.default.string
};